<template>
  <sidebar-layout :sidebarItems="sidebarItems">
    <template v-slot:mainContent>
      <router-view></router-view>
    </template>
  </sidebar-layout>
</template>

<script>
import SidebarLayout from "@/modules/commonModule/layouts/SidebarLayout";
import { createNamespacedHelpers } from "vuex";
const { mapGetters, mapMutations } = createNamespacedHelpers("nimasaAgent");

export default {
  name: "NimasaAgentMainView",
  components: { SidebarLayout },
  data() {
    return {
      sidebarItems: [
        {
          text: "Dashboard",
          link: "/nimasa-agent/dashboard",
          icon: "view-dashboard"
        },
        {
          text: "Pending Review",
          link: "/nimasa-agent/review-applications",
          icon: "file-question"
        },
        {
          text: "Accepted Applications",
          link: "/nimasa-agent/accepted-applications",
          icon: "check"
        },
        {
          text: "Denied Applications",
          link: "/nimasa-agent/rejected-applications",
          icon: "cancel"
        },
        {
          isMultiLevel: true,
          heading: "Reporting",
          icon: "folder-multiple-outline",
          children: [
            {
              text: "Active Ports Report",
              link: "/nimasa-agent/reports/active-ports",
              icon: "chevron-right"
            },
            {
              text: "Shipping Application Report",
              link: "/nimasa-agent/reports/shipping-applications",
              icon: "chevron-right"
            }
          ]
        },
        {
          text: "Profile Settings",
          link: "/nimasa-agent/profile-settings",
          icon: "settings"
        },
      ]
    };
  },
  created(){
    if(this.isNimasaManager){
      this.sidebarItems = [{
          text: "Dashboard",
          link: "/nimasa-manager/dashboard",
          icon: "view-dashboard"
        },
        {
          text: "Pending Approval",
          link: "/nimasa-manager/approve-applications",
          icon: "file-question"
        },
        {
          text: "Approved Applications",
          link: "/nimasa-manager/approved-applications",
          icon: "check"
        },
        {
          text: "Rejected Applications",
          link: "/nimasa-manager/disapproved-applications",
          icon: "cancel"
        },
        {
          text: "All Applications",
          link: "/nimasa-manager/all-applications",
          icon: "format-list-checks"
        },
        {
          isMultiLevel: true,
          heading: "Reporting",
          icon: "folder-multiple-outline",
          children: [
            {
              text: "Active Ports Report",
              link: "/nimasa-manager/reports/active-ports",
              icon: "chevron-right"
            },
            {
              text: "Shipping Application Report",
              link: "/nimasa-manager/reports/shipping-applications",
              icon: "chevron-right"
            }
          ]
        },
        {
          text: "Profile Settings",
          link: "/nimasa-manager/profile-settings",
          icon: "settings"
        },]
    }
  },
  computed:{
    ...mapGetters({
      isNimasaAgent: "isNimasaAgent",
      isNimasaManager: "isNimasaManager"
    })
  }
};
</script>
